<template>
    <div>
        <Dialog :show="show" :has-backdrop="true" :show-close-button="true" @close="emitClose">
            <div class="content">
                <h4>Spalten verwalten</h4>
                <div v-if="templatesReady" class="column_presets">
                    <RadioButton v-for="(template, i) in templates" :key="'template_'+i"
                              :id="template.id+''" :title="template.name" :value="template.value" :rounded="true"
                              @change="updateTemplate(template)"></RadioButton>
                </div>
                <div class="columns" :class="{loading: loading}">
                    <transition name="fade" mode="out-in">
                        <DotLoader v-if="loading" :key="0"></DotLoader>
                        <div class="container" v-else :key="1">
                            <Checkbox @change="changeColVal(i)" v-for="(col, i) in cols" :key="'col_'+i"
                                      :id="col.id+''" :value="col.value" :title="col.display_name"></Checkbox>
                        </div>
                    </transition>

                </div>
                <div class="button_container">
                    <AdaButton class="button_save" title="Speichern" @click="saveTemplate"></AdaButton>
                    <AdaButton class="button_save" type="button grey" title="Abbrechen" @click="emitClose"></AdaButton>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "../../components/dialogs/Dialog";
    import Checkbox from "../../components/inputs/Checkbox";
    import AdaButton from "../../components/buttons/AdaButton";
    import RadioButton from "../../components/inputs/RadioButton";

    export default {
        name: "ColumnSettingsDialog",
        components: {
            RadioButton,
            AdaButton,
            Checkbox,
            Dialog
        },
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                templatesReady: false,
                columnsReady: false,
                loading: true,
                cols: null,
                templates: null,
                original_columns: null
            }
        },
        mounted() {
            this.fetchTemplates().then(() => {
                this.templates = JSON.parse(JSON.stringify(this.vuexState.templates));
                this.loadTemplatesFromStorage();
            });
            this.fetchColumns().then(() => {
                this.cols = JSON.parse(JSON.stringify(this.vuexState.columns));
                if(this.preset){
                    this.preset.columns.forEach((presetCol)=>{
                        let index = this.cols.findIndex(x => x.name === presetCol.name);
                        this.cols[index].value = true;
                    })
                }
                this.$root.$emit("columnsLoaded");
                this.original_columns = JSON.parse(JSON.stringify(this.cols));
                this.loadColumnsFromStorage();
            });
        },
        computed: {
            vuexState() {
                return this.$store.state.columns;
            },
            ready(){
                return this.columnsReady && this.templatesReady;
            },
            preset(){
                return this.$store.state.presets.currentPreset;
            }
        },
        watch: {
            ready() {
                if (this.ready) {
                    this.loading = false;
                }
            }
        },
        methods: {
            async fetchColumns() {
                await this.$store.dispatch('columns/fetch', true);
            },
            async fetchTemplates() {
                await this.$store.dispatch('columns/fetchTemplates', true);
            },
            saveTemplate() {
                let activeTemplate = this.templates.find((x => x.value === true));
                this.$store.commit('columns/updateTemplate', activeTemplate);
                this.$store.commit('columns/updateColumns', this.cols);
                this.original_columns = JSON.parse(JSON.stringify(this.cols));
                this.$emit('close');
                this.emitChange();
                this.saveToStorage();
                this.$noty.success("Erfolgreich gespeichert");
            },
            updateTemplate(template) {
                this.templates.forEach((temp) => {
                    temp.value = temp.id === template.id;
                });
                this.cols.forEach((col) => {
                    col.value = typeof template.columns.find((x => x.id === col.id)) !== "undefined";
                });
            },
            reset() {
                this.templates = JSON.parse(JSON.stringify(this.vuexState.templates));
                this.cols = JSON.parse(JSON.stringify(this.original_columns));
            },
            changeColVal(index){
                this.cols[index].value = !this.cols[index].value;
            },
            emitChange(){
                this.$root.$emit('reloadDeals');
            },
            loadColumnsFromStorage(){
                let items = null;
                if (this.$route.name === 'deals') {
                    items = sessionStorage.getItem('columnSettingsAll');
                } else if (this.$route.name === 'mydealsall') {
                    items = sessionStorage.getItem('columnSettingsMy');
                } else if (this.$route.name === 'mydeals') {
                    items = sessionStorage.getItem('columnSettingsPreset');
                }

                if(items){
                    items = JSON.parse(items);
                }

                if(items && items.length === this.cols.length){
                    for (let i = 0; i < this.cols.length; i++) {
                        this.cols[i].value = items[i].value;
                    }
                    this.$store.commit('columns/updateColumns', this.cols);
                    this.original_columns = JSON.parse(JSON.stringify(this.cols));
                    this.emitChange();
                }
                this.columnsReady= true;
            },
            loadTemplatesFromStorage(){
                let items = null;
                if (this.$route.name === 'deals') {
                    items = sessionStorage.getItem('templateSettingsAll');
                } else if (this.$route.name === 'mydealsall') {
                    items = sessionStorage.getItem('templateSettingsMy');
                } else if (this.$route.name === 'mydeals') {
                    items = sessionStorage.getItem('templateSettingsPreset');
                }

                if(items){
                    items = JSON.parse(items);
                }

                if(items && items.length === this.templates.length){
                    for (let i = 0; i < this.templates.length; i++) {
                        this.templates[i].value = items[i].value;
                    }

                    let activeTemplate = this.templates.find((x => x.value === true));
                    this.$store.commit('columns/updateTemplate', activeTemplate);
                    this.emitChange();
                }
                this.templatesReady= true;

            },
            saveToStorage(){
                if (this.$route.name === 'deals') {
                    sessionStorage.setItem('templateSettingsAll', JSON.stringify(this.templates));
                } else if (this.$route.name === 'mydealsall') {
                    sessionStorage.setItem('templateSettingsMy', JSON.stringify(this.templates));
                } else if (this.$route.name === 'mydeals') {
                    sessionStorage.setItem('templateSettingsPreset', JSON.stringify(this.templates));
                }

                if (this.$route.name === 'deals') {
                    sessionStorage.setItem('columnSettingsAll', JSON.stringify(this.cols));
                } else if (this.$route.name === 'mydealsall') {
                    sessionStorage.setItem('columnSettingsMy', JSON.stringify(this.cols));
                } else if (this.$route.name === 'mydeals') {
                    sessionStorage.setItem('columnSettingsPreset', JSON.stringify(this.cols));
                }
            },
            emitClose(){
                this.reset();
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        display: flex;
        flex-direction: column;
    }

    .column_presets {
        padding: 0 15px;

        .checkbox-container:first-child {
            margin-left: 0;
        }

        .checkbox-container:last-child {
            margin-right: 0;
        }
    }

    $columnContainerWidth: 570px;
    .columns {
        border: 1px solid #d0d4da;
        margin-top: 20px;
        width: $columnContainerWidth;
        transition: all 0.3s ease-in-out;
        display: flex;
        justify-content: center;
        min-height: 150px;
        max-height: 387px;
        align-items: center;

        .checkbox-container {
            margin: 0 15px 10px 0;
            min-width: calc((#{$columnContainerWidth} / 3) - 16px);

            &:nth-child(3n){
                margin-right: 0;
            }
        }

        .container {
            height: 100%;
            overflow: auto;
            padding: 10px 0 10px 15px;

            &::-webkit-scrollbar {
                width: 10px;
            }

            &::-webkit-scrollbar-track {
                background-color: #eceef0;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #d0d4da;
            }
        }
    }

    .button_container{
        display: flex;
        margin-top: 20px;
    }
    .button_save {
        width: fit-content;
        margin-right: 20px;
    }
</style>